import { showCheckboxes } from './multiDropdownHelpers';

export default function MultiDropdown({
  dropdownOptions,
  defaultChecked,
  handleSelectedChange,
  handleSelectDeselectAll,
  selectMessage
}) {
  const checkAllBoxes = (checked) => {
    let checkbox = document.getElementsByName('checkbox');
    for (var i = 0; i < checkbox.length; i++) {
      checkbox[i].checked = checked;
      handleSelectDeselectAll(checked);
    }
  };

  return (
    <div className='multidropdown'>
      <div onClick={showCheckboxes}>
        <select className='dropdown'>
          <option key='' value=''>
            {selectMessage}
          </option>
        </select>
        <div className='overselect'></div>
      </div>
      <div id='check-boxes'>
        <label key='Select or Deselect' className='selectdeselect'>
          <input
            type='checkbox'
            name='checkbox'
            onClick={(e) => {
              checkAllBoxes(e.target.checked);
            }}
          />
          Select/Deselect All
        </label>
        {Object.keys(dropdownOptions).map((key) => (
          <label key={key}>
            <input
              type='checkbox'
              name='checkbox'
              value={dropdownOptions[key]}
              onClick={(e) => {
                handleSelectedChange(e.target.value);
              }}
              defaultChecked={
                defaultChecked.includes(dropdownOptions[key]) ? true : false
              }
            />
            {`  ${key}`}
          </label>
        ))}
      </div>
    </div>
  );
}
